import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const anonymous = { unauthorized: true }
const master = { unauthorized: false, hasAnyRoles: ['ROLE_MASTER'] }

const adminMaster = { unauthorized: false, hasAnyRoles: ['ROLE_MASTER', 'ROLE_HOST', 'ROLE_STORE'] }
const adminHost = { unauthorized: false, hasAnyRoles: ['ROLE_MASTER', 'ROLE_HOST', 'ROLE_HOST_SUB'] }
const adminStore = { unauthorized: false, hasAnyRoles: ['ROLE_MASTER', 'ROLE_STORE', 'ROLE_STORE_SUB'] }
const adminAll = { unauthorized: false, hasAnyRoles: ['ROLE_MASTER', 'ROLE_HOST', 'ROLE_HOST_SUB', 'ROLE_STORE', 'ROLE_STORE_SUB'] }

const ADM_MAIN = () => import(/* webpackChunkName: "ADM_MAIN" */ /* webpackPrefetch: false */ '@/views/ADM_MAIN.vue');

const ADM_SIGN_IN = () => import(/* webpackChunkName: "ADM_MAIN" */ /* webpackPrefetch: false */ '@/views/sign/ADM_SIGN_IN.vue');
const ADM_SING_OUT = () => import(/* webpackChunkName: "ADM_SING_OUT" */ /* webpackPrefetch: false */ '@/views/sign/ADM_SING_OUT.vue');

const ADM_STORE_LIST = () => import(/* webpackChunkName: "ADM_STORE_LIST" */ /* webpackPrefetch: false */ '@/views/store/ADM_STORE_LIST.vue');
const ADM_STORE_EDT = () => import(/* webpackChunkName: "ADM_STORE_EDT" */ /* webpackPrefetch: false */ '@/views/store/ADM_STORE_EDT.vue');

const ADM_UPDATE_LIST = () => import(/* webpackChunkName: "ADM_UPDATE_LIST" */ /* webpackPrefetch: false */ '@/views/config/ADM_UPDATE_LIST.vue');
const ADM_UPDATE_EDT = () => import(/* webpackChunkName: "ADM_UPDATE_EDT" */ /* webpackPrefetch: false */ '@/views/config/ADM_UPDATE_EDT.vue');

const ADM_CSC_NTC = () => import(/* webpackChunkName: "ADM_CSC_NTC" */ /* webpackPrefetch: false */ '@/views/cs/ADM_CSC_NTC.vue');
const ADM_CSC_NTC_ADD = () => import(/* webpackChunkName: "ADM_CSC_NTC_ADD" */ /* webpackPrefetch: false */ '@/views/cs/ADM_CSC_NTC_ADD.vue');

const routes = [
    { path: '/sign/in', name: 'SignIn', meta: anonymous, component: ADM_SIGN_IN },
    { path: '/sign/out', name: 'SignOut', meta: adminAll, component: ADM_SING_OUT },

    { path: '/store/list', name: 'ADM_STORE_LIST', meta: master, component: ADM_STORE_LIST },
    { path: '/store/edt', name: 'ADM_STORE_EDT', meta: master, component: ADM_STORE_EDT },

    { path: '/update/list', name: 'ADM_UPDATE_LIST', meta: master, component: ADM_UPDATE_LIST },
    { path: '/update/edt', name: 'ADM_UPDATE_EDT', meta: master, component: ADM_UPDATE_EDT },

    { path: '/cs/notice', name: 'ADM_CSC_NTC', meta: master, component: ADM_CSC_NTC },
    { path: '/cs/notice/add', name: 'ADM_CSC_NTC_ADD', meta: master, component: ADM_CSC_NTC_ADD },

    { path: '/', name: 'MAIN', meta: adminAll, component: ADM_MAIN },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    base: process.env.BASE_URL,
    linkExactActiveClass: 'router-link-exact-active',
    routes
})

router.beforeEach((to, from, next) => {

    checkInfo()

    const token = store.getters['basic/accessToken'];
    const userRoles = store.getters['basic/userRoles'];

    let intersection = [];
    const anyRoles = to.meta.hasAnyRoles;
    if(anyRoles){
        intersection = userRoles.filter(x => anyRoles.includes(x.id))
    }

    if(to.meta.unauthorized){
        if(hasToken(token)){
            switch (to.path) {
                case "/sign/in":
                    return next({name: 'MAIN'});
                default:
                    return next();
            }
        }else{
            return next();
        }

    }else{
        if(hasToken(token)){
            if(intersection.length > 0){
                return next();
            }else{
                // alert("접근 권한이 없습니다.");
                // return next(from);
                return next();
            }

        }else{
            return next({name: 'SignIn'});
        }
    }

})

function checkInfo (){
    const expired = store.getters['basic/expired'];
    if (expired === ''){
        return
    }

    if(checkExpired(expired)){
        // initInfo(store)
        // window.app.config.globalProperties.$warning("warning.logout.timeout")
    }
}
function initInfo (store){
    store.dispatch('basic/setAuth', makeInitObj())
    store.dispatch('basic/initUser')
}

function makeInitObj (){
    return {
        accessToken: '',
            refreshToken: '',
        expired: '',
        userRoles: []
    }
}

function checkExpired(expired){
    return Date.parse(expired) < new Date().getTime()
}

function hasToken (token){
    if (token === null || token === '') {
        return false;
    }
    return true;
}

export default router
